/**
 * Model definition for Generic Comparison Price Free
 */
export interface InternGenericComparisonPriceFree {
  __component: 'intern.generic-comparison-price-free';
  id: string;
  text: string;
}

export function isInternGenericComparisonPriceFree(obj: {
  __component?: string;
}): obj is InternGenericComparisonPriceFree {
  return obj.__component === 'intern.generic-comparison-price-free';
}
